const getters = {
    username: state => state.login.username, //用户名
    shop_index: state => state.shop_index,//商城首页分类
    viewLoading: state => state.view.isLoading,//页面加载中
    maskShow: state => state.view.maskShow, //遮罩
    headerShow: state => state.view.headerShow, //页头
    footerShow: state => state.view.footerShow, //页脚
    viewrouter: state => state.router.powerRouter,//路由权限列表
    cartAmount: state => state.shoppingCart.cartAmount, //购物车商品数量
    commdityQuery: state => state.commdity.query, //商品详情页面参数
    cartList: state => state.order.cartList //购物车结算时的订单商品
  };
  export default getters